const financeOptions = [
  {
    title: 'Installment payment',
    id: 'installmentPayment',
    interestAPR: 0,
    monthsToPay: [{ repaymentFactor: 0, months: 36 }],
    administrativeFee: 45
  },
  {
    title: 'Loan',
    id: 'loan',
    interestAPR: 7.95,
    monthsToPay: [{ repaymentFactor: 0, months: 36 }],
    administrativeFee: 45,
  },
]
const lowDeposit = 0
const highDeposit = 0
const showFinance = false
const showBada = false
const hasMonthlyPayment = true
const hasFullVersion = false
const hasMagnetSimplifiedVersion = false

export default {
  financeOptions,
  lowDeposit,
  highDeposit,
  showBada,
  showFinance,
  hasMonthlyPayment,
  hasFullVersion,
  hasMagnetSimplifiedVersion,
}
